<app-navbar customHeader="true" >
    <div class="container-page">
      <div class="left-content">
        <form class="split-box p4">
          <fieldset class="p-md-4 p-0">
            <h2 class="legend-title">Bem-vindo(a) ao Portal Investidor!</h2>
            <p class="register-desc">
              Cadastre-se para iniciar o processo de solicitação de Garantia Ordinária ou Especial DPGE.
            </p>
            <p class="register-desc">
              A garantia ordinária para pessoas físicas deve ser solicitada pelo aplicativo para celulares.
            </p>
            <div class="timeline">
              <div class="step active">
                <div class="circle">1</div>
                <div class="line-one"></div>
                <div class="content">
                  <h3>Crie sua conta</h3>
                  <p>Preencha seus dados como solicitante da(s) garantia(s)</p>
                </div>
              </div>

              <div class="step">
                <div class="circle">2</div>
                <div class="line-two"></div>
                <div class="content">
                  <h3>Acesse sua conta</h3>
                  <p>Acesse o portal com suas credenciais</p>
                </div>
              </div>

              <div class="step">
                <div class="circle">3</div>
                <div class="content">
                  <h3>Solicite garantia</h3>
                  <p>Preencha os dados e envie a solicitação</p>
                </div>
              </div>
            </div>
            <!-- <legend>Realizar Cadastro</legend> -->
            <div class="d-flex justify-content-center align-center mt-3">
              <button (click)='cadastro()' class="btn-new-account">Criar conta</button>
            </div>

            <div class="info-container">
              <legend class="info-title">Já usa o app FGC?</legend>
              <div class="custom-box-alert mt-4">
                <i class="fas fa-info-circle"></i>
                <p>Se você já possui cadastro no aplicativo do FGC, não é necessário criar um novo cadastro. Basta acessar o Portal Investidor como CPF e a senha cadastrados no app.</p>
              </div>
            </div>

          </fieldset>
        </form>
      </div>
      <div class="right-content">
        <div class="card-login">
          <form class="box-form d-flex align-items-center h-100 p-4" [formGroup]="formLogin">
            <fieldset>
              <legend class="legend-title">Acesse sua conta</legend>
              <span>Acesse sua conta para gerenciar suas garantias. </span>
              <div class="form-row mt-3">
                <div class="form-group col-sm-12">
                  <label class="form-label">CPF *</label>
                  <input mask="000.000.000-00" name="cpf" formControlName="documento" type="text"  class="form-control custom-input" placeholder="000.000.000-00">
                </div>
                <div class="form-group col-sm-12 ">
                  <label class="form-label">Senha *</label>
                  <div class="password-container">
                    <input name="senha" formControlName="senha" [type]="mostrarSenha ? 'text' : 'password'" class="form-control custom-input" placeholder="Digite sua senha">
                    <i class="fas" [ngClass]="mostrarSenha ? 'fa-eye-slash' : 'fa-eye'" (click)="mostrarSenha = !mostrarSenha"></i>
                  </div>
                </div>
                <div class="form-group col-sm-12">
                  <a (click)='resetSenha()' class="btn-lost-password"> <u> Esqueceu a senha? </u></a>
                </div>
              </div>
              <div class="form-row d-flex justify-content-center">
                <button (click)='openModal()' class="btn">Entrar</button>
              </div>
              <div class="form-row d justify-content-center">
                <a href="#" class="btn-voltar">
                  ← Voltar à página inicial
                </a>
              </div>

            </fieldset>
          </form>
        </div>


      </div>
    </div>
</app-navbar>
